if (!customElements.get('vbb-product-tabs')) {
  customElements.define('vbb-product-tabs', class ProductTabs extends HTMLElement {
    constructor() {
      super();
    }

    handleTabChange(event) {
      this.handleNavUpdate(event);
      this.handlePanelUpdate(event);
    }

    handleNavUpdate(event) {
      this.clearActiveNav();
      this.setActiveNav(event);
    }

    handlePanelUpdate(event) {
      this.clearActivePanel();
      this.setActivePanel(event);
    }

    clearActiveNav() {
      document.querySelectorAll('.vbb-product-tabs__navigation li').forEach((navItem) => {
        navItem.dataset.active = false;
        navItem.firstElementChild.setAttribute('aria-selected', false);
      });
    }

    setActiveNav(event, index = null) {
      let activeTab;

      if (event != null) activeTab = event.target.closest('button');
      if (index != null) activeTab = this.querySelectorAll('.vbb-product-tabs__navigation button')[index];

      if (activeTab) {
        activeTab.parentElement.dataset.active = true;
        activeTab.setAttribute('aria-selected', true);
      }

      activeTab.focus();
    }

    clearActivePanel() {
      document.querySelectorAll('.vbb-product-tabs__panel').forEach((panel) => {
        panel.classList.remove('vbb-product-tabs__panel--active');
        panel.setAttribute('aria-hidden', true);
      });
    }

    setActivePanel(event, index = null) {
      let activePanel;

      if (event != null) activePanel = document.querySelector(`#${event.target.closest('button').dataset.target}`);
      if (index != null) activePanel = document.querySelector(`#${this.querySelectorAll('.vbb-product-tabs__navigation button')[index].dataset.target}`);

      if (activePanel) {
        activePanel.classList.add('vbb-product-tabs__panel--active');
        activePanel.setAttribute('aria-hidden', false);
      }
    }

    selectTab(index) {
      this.clearActiveNav();
      this.clearActivePanel();

      if (index < 0) {
        this.setActiveNav(null, this.maxTabIndex);
        this.setActivePanel(null, this.maxTabIndex);
      } else if (index > this.maxTabIndex) {
        this.setActiveNav(null, 0);
        this.setActivePanel(null, 0);
      } else {
        this.setActiveNav(null, index);
        this.setActivePanel(null, index);
      }
    }

    handleKeyDown(event) {
      switch (event.key) {
        case 'ArrowLeft':
          this.selectTab(this.currentTabIndex - 1);
          break;
        case 'ArrowRight':
          this.selectTab(this.currentTabIndex + 1);
          break;
        case 'Home':
          this.selectTab(0);
          break;
        case 'End':
          this.selectTab(this.maxTabIndex);
          break;
        default:
          break;
      }
    }

    get currentTab() {
      return this.querySelector('.vbb-product-tabs__navigation li[data-active=true]');
    }

    get currentTabIndex() {
      return Array.from(this.querySelectorAll('.vbb-product-tabs__navigation li')).indexOf(this.currentTab);
    }

    get maxTabIndex() {
      return this.querySelectorAll('.vbb-product-tabs__navigation li').length - 1;
    }

    connectedCallback() {
      this.querySelectorAll('.vbb-product-tabs__navigation button').forEach(button => {
        button.addEventListener('keydown', this.handleKeyDown.bind(this));
        button.addEventListener('click', this.handleTabChange.bind(this));
      });
    }
  });
}
